export default{
    id:"id",
    trainingProgramName:"title",
    content:"content",
    createdAt:"created_at"
}